/**
 * DevExtreme (esm/__internal/grids/grid_core/master_detail/utils.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export function isDetailRow(row) {
  const rowType = null === row || void 0 === row ? void 0 : row.rowType;
  return "detail" === rowType || "detailAdaptive" === rowType;
}